import { render, staticRenderFns } from "./ProgressTag.vue?vue&type=template&id=4e2da0d6&lang=pug"
import script from "./ProgressTag.vue?vue&type=script&lang=js"
export * from "./ProgressTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports